import { Grid } from "grommet";
import { useIsLarge } from "@cybertools/grommet/useIsLarge";
import Teaser from "./teaser";

const inline = {
  columns: ["auto"],
  // rows: ["120px"],
};

const detailed = {
  rows: ["auto"],
  columns: ["1fr", "1fr", "1fr"],
};

export default function List({ articles, ...rest }) {
  const large = useIsLarge();

  return (
    <Grid
      gap="large"
      margin={large ? "none" : { horizontal: "medium" }}
      {...(large ? detailed : inline)}
      {...rest}
    >
      {articles.map((article) => (
        <Teaser key={article.id} {...article} />
      ))}
    </Grid>
  );
}
